import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Table } from 'primeng/table';
import { ConversaoLibraConverte } from '../../../shared/conversao-libra/conversao-libra-converte';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { FiltroDealers } from './filtro-dealer';
import { IndicadorVendaOficinaFiltroService } from './indicador-venda-oficina-filtro.service';
import { IndicadorVendaOficinaService } from './indicador-venda-oficina.service';

declare var $: any;

@Component({
  selector: 'app-indicador-venda-oficina',
  templateUrl: './indicador-venda-oficina.component.html',
  styleUrls: ['./indicador-venda-oficina.component.scss']
})
export class IndicadorVendaOficinaComponent implements OnInit {
  @Input() filtros: any;

  form: FormGroup;
  subscription: any;
  selecionado: object;
  selecionados = [];
  cols: any[];
  _selectedColumns: any[];
  dealersDados: any[] = [];
  numero_nfe: any;
  serie: any;
  id_dealer: any;
  first = 0;
  displayRows: number = 0;
  rows = 20;
  totalRecords = 0;
  loading: boolean = false;
  displayFiltros: boolean = false;
  displayFiltrosDealers: boolean = false;
  nomeModulo: string;
  dataInicial: Date;
  dataFinal: Date;
  maxDate: Date = new Date();
  filtrosDealers: FiltroDealers;
  display: boolean = false;
  cargaTela: boolean;

  @ViewChild('dt') dt: Table;

  dadosTranslate = {
    "Dealer Number": "businessIntelligence.indicadorVendaOficina.dealerCod",

    "Dealer": "businessIntelligence.indicadorVendaOficina.codDealer",
    // "Dealer Name": "businessIntelligence.indicadorVendaOficina.nomeDealer",
    "Número O.S": "businessIntelligence.indicadorVendaOficina.numeroOs",
    "ID Número O.S": "businessIntelligence.indicadorVendaOficina.idNumeroOS",
    "Tipo": "businessIntelligence.indicadorVendaOficina.tipo",
    "Cliente": "businessIntelligence.indicadorVendaOficina.nomeCliente",
    "Chassi": "businessIntelligence.indicadorVendaOficina.numeroChassi",
    "Modelo": "businessIntelligence.indicadorVendaOficina.descModelo",
    "Consultor": "businessIntelligence.indicadorVendaOficina.nomeConsultor",
    "PN": "businessIntelligence.indicadorVendaOficina.partNumber",
    "QUantidade": "businessIntelligence.indicadorVendaOficina.quantidade",
    "Item": "businessIntelligence.indicadorVendaOficina.descricaoItem",
    "Custo": "businessIntelligence.indicadorVendaOficina.custoVendaItem",
    "Venda": "businessIntelligence.indicadorVendaOficina.valorVendaItem",
    "Abertura O.S": "businessIntelligence.indicadorVendaOficina.dataAbertura",
    "Encerramento O.S": "businessIntelligence.indicadorVendaOficina.dataFechamento",
    "Recepcionista": "businessIntelligence.indicadorVendaOficina.recepcionista"
  }

  constructor(private service: IndicadorVendaOficinaService,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private servico: IndicadorVendaOficinaFiltroService,
    private exportExcelService: ExportExcelService,
    private fb: FormBuilder) {
    this.filtros = {};
    this.nomeModulo = 'indicador-venda-oficina';
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format('DD-MM-YYYY')],
      data_final: [moment(this.dataFinal).format('DD-MM-YYYY')],
      dealers: [''],
      partNumber: [''],
      numeroOs: [''],
      numeroChassi: [''],
      tipo: [''],
      original: ['']
    });

    this.maxDate.setDate(this.maxDate.getDate());
  }

  ngOnInit() {
    this.cargaTela = true;
    this.changeLanguageValue();
    // this.preencherOrigem();

    this.cols = [
      { field: "codDealer", header: "businessIntelligence.indicadorVendaOficina.codDealer", headerBr: "Dealer", headerGb: "Dealer" },
      // { field: "nomeDealer", header: "businessIntelligence.indicadorVendaOficina.nomeDealer", headerBr: "Dealer Name", headerGb: "Dealer Name" },
      { field: "numeroOs", header: "businessIntelligence.indicadorVendaOficina.numeroOs", headerBr: "Número O.S", headerGb: "Número O.S" },
      { field: "idNumeroOs", header: "businessIntelligence.indicadorVendaOficina.idNumeroOS", headerBr: "ID Número O.S", headerGb: "ID Número O.S" },
      { field: "tipo", header: "businessIntelligence.indicadorVendaOficina.tipo", headerBr: "Tipo", headerGb: "Tipo" },
      { field: "nomeCliente", header: "businessIntelligence.indicadorVendaOficina.nomeCliente", headerBr: "Cliente", headerGb: "Cliente" },
      { field: "numeroChassi", header: "businessIntelligence.indicadorVendaOficina.numeroChassi", headerBr: "Chassi", headerGb: "Chassi" },
      { field: "descModelo", header: "businessIntelligence.indicadorVendaOficina.descModelo", headerBr: "Modelo", headerGb: "Modelo" },
      { field: "recepcionista", header: "businessIntelligence.indicadorVendaOficina.recepcionista", headerBr: "Recepcionista", headerGb: "Recepcionista" },
      { field: "nomeConsultor", header: "businessIntelligence.indicadorVendaOficina.nomeConsultor", headerBr: "Consultor", headerGb: "Consultor" },
      { field: "partNumber", header: "businessIntelligence.indicadorVendaOficina.partNumber", headerBr: "PN", headerGb: "PN" },
      { field: "quantidade", header: "businessIntelligence.indicadorVendaOficina.quantidade", headerBr: "Quantidade", headerGb: "Quantity" },
      { field: "descricaoItem", header: "businessIntelligence.indicadorVendaOficina.descricaoItem", headerBr: "Item", headerGb: "Item" },
      { field: "custoVendaItem", header: "businessIntelligence.indicadorVendaOficina.custoVendaItem", headerBr: "Custo", headerGb: "Custo" },
      { field: "valorVendaItem", header: "businessIntelligence.indicadorVendaOficina.valorVendaItem", headerBr: "Venda", headerGb: "Venda" },
      { field: "desconto", header: "businessIntelligence.indicadorVendaOficina.desconto"},
      { field: "vendaLiquido", header: "businessIntelligence.indicadorVendaOficina.vendaLiquido"},
      { field: "dataAberturaString", header: "businessIntelligence.indicadorVendaOficina.dataAbertura", headerBr: "Abertura O.S", headerGb: "Abertura O.S" },
      { field: "dataFechamentoString", header: "businessIntelligence.indicadorVendaOficina.dataFechamento", headerBr: "Encerramento O.S", headerGb: "Encerramento O.S" }
    ];

    this._selectedColumns = this.cols;

    this.filtrosDealers.carregar();
    this.getAll();
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  get f() { return this.form.controls; }

  private shouldShowIdNumeroOs(rows: any[]): boolean {
    // mostra a coluna se existir ao menos 1 linha onde idNumeroOs != null 
    // E idNumeroOs != numeroOs
    return rows?.some(d =>
      d?.idNumeroOs != null &&
      d?.idNumeroOs !== undefined &&
      d?.idNumeroOs !== '' &&
      d?.numeroOs != null &&
      String(d.idNumeroOs) !== String(d.numeroOs)
    );
  }

  private getAll() {
    this.loading = true;

    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value,
      this.f.partNumber.value, this.f.numeroOs.value, this.f.numeroChassi.value, this.f.tipo.value, this.f.original.value).subscribe(dados => {
        this.dealersDados = dados.dealers ?? [];
        this.orderByDate();

        // formatações de exibição
        this.dealersDados.forEach(element => {
          const atual = this.conversaoLibraConverte.conversaoLibra(element.valorVendaItem, null, null);
          const valorFormatado = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(atual);
          element.valorVendaItem = valorFormatado.replace("R$", "");
          element.dataAbertura = element.dataAbertura.substring(0, 10);
          element.dataFechamento = element.dataFechamento.substring(0, 10);
          // NÃO altere idNumeroOs aqui; deixe null como null.
        });

        // decide se mostra/oculta a coluna
        const exibirIdNumeroOs = this.shouldShowIdNumeroOs(this.dealersDados);
        if (!exibirIdNumeroOs) {
          // remove a coluna quando não há retorno do back-end ou todos são iguais/null
          this._selectedColumns = this.cols.filter(c => c.field !== 'idNumeroOs');
        } else {
          // garante que a coluna exista logo após numeroOs
          if (!this._selectedColumns.find(c => c.field === 'idNumeroOs')) {
            const idCol = this.cols.find(c => c.field === 'idNumeroOs');
            const idxNumero = this._selectedColumns.findIndex(c => c.field === 'numeroOs');
            if (idCol) {
              if (idxNumero >= 0) {
                const semId = this._selectedColumns.filter(c => c.field !== 'idNumeroOs');
                semId.splice(idxNumero + 1, 0, idCol);
                this._selectedColumns = semId;
              } else {
                this._selectedColumns = [...this._selectedColumns, idCol];
              }
            }
          }
        }

        this.loading = false;
        this.cargaTela = false;
      });
  }

  private orderByDate() {
    this.dealersDados.sort((a, b) => {
      let data_a = a.data;
      let data_b = b.data;

      if (data_a > data_b) return -1;
      if (data_a < data_b) return 1;

      return 0;
    });
  }

  private tratarData() {
    const dataInicio = new Date();
    const dataFim = new Date();

    let firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);

    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public filtroAPI() {
    this.displayFiltros = false;

    this.f.data_inicial.setValue(moment(this.dataInicial).format('DD-MM-YYYY'));
    this.f.data_final.setValue(moment(this.dataFinal).format('DD-MM-YYYY'));

    this.filtrosSelecionados();
    this.getAll();
  }

  private filtrosSelecionados() {
    const dealers = [];

    this.incluirFiltroDealers(dealers);

    this.filtros.dealers = dealers.map(r => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealers.setValue(this.filtros.dealers[0]);
    } else {
      this.f.dealers.setValue('');
    }
  }

  public getListagemComFiltros(): boolean {
    return this.dataInicial
      || this.dataFinal
      || this.f.partNumber.value
      || this.f.numeroOs.value
      || this.f.numeroChassi.value
      || this.f.tipo.value
      || this.f.original.value
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  public exibirFiltro() {
    this.displayFiltros = true;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  public limparFiltros() {
    this.f.partNumber.setValue('');
    this.f.numeroOs.setValue('');
    this.f.numeroChassi.setValue('');
    this.f.tipo.setValue('');
    this.f.original.setValue('');
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getUTCFullYear(), dataInicio.getMonth(), 1);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  protected getTranslate(value) {

    return this.dadosTranslate[value];
  }

  private translateHeader(item) {
    if (item == "businessIntelligence.indicadorVendaOficina.codDealer") {
      return "Cód. Dealer";
    }
    // if (item == "businessIntelligence.indicadorVendaOficina.nomeDealer") {
    //   return this.translate.currentLang == "br" ? "Nome Dealer" : "Dealer Name";
    // }
    if (item == "businessIntelligence.indicadorVendaOficina.numeroOs") {
      return this.translate.currentLang == "br" ? "Número O.S" : "O.S Number";
    }
    if (item == "businessIntelligence.indicadorVendaOficina.idNumeroOS") {
      return this.translate.currentLang == "br" ? "ID Número O.S" : "ID O.S Number";
    }
    if (item == "businessIntelligence.indicadorVendaOficina.tipo") {
      return this.translate.currentLang == "br" ? "Tipo" : "Type";
    }
    if (item == "businessIntelligence.indicadorVendaOficina.nomeCliente") {
      return this.translate.currentLang == "br" ? "Cliente" : "Client";
    }
    if (item == "businessIntelligence.indicadorVendaOficina.numeroChassi") {
      return this.translate.currentLang == "br" ? "Chassi" : "Chassis";
    }
    if (item == "businessIntelligence.indicadorVendaOficina.descModelo") {
      return this.translate.currentLang == "br" ? "Modelo" : "Model";
    }
    if (item == "businessIntelligence.indicadorVendaOficina.recepcionista") {
      return this.translate.currentLang == "br" ? "Recepcionista" : "Receptionist";
    }
    if (item == "businessIntelligence.indicadorVendaOficina.nomeConsultor") {
      return this.translate.currentLang == "br" ? "Consultor" : "Consultant";
    }
    if (item == "businessIntelligence.indicadorVendaOficina.partNumber") {
      return "PN";
    }
    if (item == "businessIntelligence.indicadorVendaOficina.quantidade") {
      return this.translate.currentLang == "br" ? "Quantidade" : "Quantity";
    }
    if (item == "businessIntelligence.indicadorVendaOficina.descricaoItem") {
      return "Item";
    }
    if (item == "businessIntelligence.indicadorVendaOficina.custoVendaItem") {
      return this.translate.currentLang == "br" ? "Custo" : "Cost";
    }
    if (item == "businessIntelligence.indicadorVendaOficina.valorVendaItem") {
      return this.translate.currentLang == "br" ? "Venda" : "Sale";
    }
    if (item == "businessIntelligence.indicadorVendaOficina.desconto") {
      return this.translate.currentLang == "br" ? "Desconto" : "Discount";
    }
    if (item == "businessIntelligence.indicadorVendaOficina.vendaLiquido") {
      return this.translate.currentLang == "br" ? "Venda Liquida" : "Net Sale";
    }
    if (item == "businessIntelligence.indicadorVendaOficina.dataAbertura") {
      return this.translate.currentLang == "br" ? "Abertura O.S" : "Opening O.S";
    }
    if (item == "businessIntelligence.indicadorVendaOficina.dataFechamento") {
      return this.translate.currentLang == "br" ? "Encerramento O.S" : "Closure O.S";
    }


  }

  private translateField(item) {
    return item;
  }

  public exportExcel() {
    let registros = [];

    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealers.value,
      this.f.partNumber.value, this.f.numeroOs.value, this.f.numeroChassi.value, this.f.tipo.value, this.f.original.value).subscribe(dados => {
        registros = dados.dealers;
        this.orderByDate();

        registros.forEach(dados => {
          const atual = this.conversaoLibraConverte.conversaoLibra(dados.valorVenda, null, null);
          const valorFormatado = Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(atual);
          // dados.valorVenda = valorFormatado.replace("R$", "");
          dados.dataAbertura = dados.dataAbertura.substring(0, 10);
          dados.dataFechamento = dados.dataFechamento.substring(0, 10);
          // NÃO altere idNumeroOs aqui; deixe null como null.
        });

        if (registros.length > 0) {
          this.exportExcelService.nomeModulo = this.nomeModulo;
          this.exportExcelService.formatType = "0.00";
          // this.exportExcelService.colunasFormatacao = [0];
          // this.exportExcelService.colunasFormatacao = [6];
          this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
            let linha = {};

            this._selectedColumns.forEach(c => {
              linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
            });

            return linha;
          }));
        }
      });
  }

  private changeLanguageValue() {
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.getAll();
      });
  }

}
